export {}

const printButton = document.querySelector(".s-product-detail-info__print")

const SetContentHeight = (content, contentBlockEnd) => {
  const offsetHeight = contentBlockEnd.offsetHeight
  const offsetTop = contentBlockEnd.offsetTop
  const height = offsetHeight + offsetTop + 64 + 52 //first title after last visible block
  content.style.height = height + "px"
}

printButton?.addEventListener("click", () => {
  window.print();
})
const contents = document.querySelectorAll<HTMLElement>(".s-product-detail-info__top")
contents.forEach(content => {
  const contentBlocks = content.querySelectorAll<HTMLElement>(".s-product-detail-info__top-block")
  const contentBlockEnd = content.querySelector<HTMLElement>(".s-product-detail-info__top-block.--show-more-end")
  const openButton = content.querySelector<HTMLElement>(".s-product-detail-info__more")

  if(!contentBlockEnd) {
    openButton?.classList.add('--hidden');
    content.closest('.s-product-detail-info')?.classList.remove('--bottom-line');
    return;
  }

  SetContentHeight(content, contentBlockEnd)

  openButton?.addEventListener("click", () => {
    openButton.classList.toggle("--open")
    content.classList.toggle("--open")
    if (content.classList.contains("--open")) {
      content.style.height = "auto"
    }
    else {
      SetContentHeight(content, contentBlockEnd)
    }
  })

  let windowWidth = window.innerWidth
  window.addEventListener("resize", () => {

    if (window.innerWidth != windowWidth) {
      windowWidth = window.innerWidth
      SetContentHeight(content, contentBlocks)
    }
  });
});

